// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quotation-detail-page {
    max-width: 1200px;
    margin: 40px auto;
    padding: 0 20px;
    font-family: 'Noto Sans KR', sans-serif;
    color: #333;
}

.qd-breadcrumb {
    font-size: 14px;
    color: #888;
    margin-bottom: 40px;
}

.qd-breadcrumb .current {
    font-weight: 500;
    color: #333;
}

.qd-main-title {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 50px;
}

.qd-summary-box {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    border: 1px solid #ddd;
    padding: 20px;
    margin-bottom: 40px;
}

.qd-summary-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px 30px;
    flex-grow: 1;
}

.qd-summary-vertical {
    display: flex;
    flex-direction: column;
    gap: 15px;
    flex-grow: 1;
}

.qd-summary-item {
    font-size: 15px;
}

.qd-summary-item .label {
    font-weight: bold;
    display: inline-block;
    width: 100px;
    margin-right: 15px;
}

.qd-summary-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.qd-btn-dark, .qd-btn-light, .qd-btn-primary {
    padding: 10px 20px;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
}

.qd-btn-dark {
    background-color: #333;
    border: 1px solid #333;
    color: #fff;
}

.qd-btn-light {
    background-color: #fff;
    border: 1px solid #ccc;
    color: #333;
}

.qd-product-list-header {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 15px;
    background-color: #f9f9f9;
    border-top: 2px solid #333;
    border-bottom: 1px solid #ddd;
}

.qd-product-list-cols {
    display: grid;
    grid-template-columns: 3fr 1fr 2fr 1.5fr 1.5fr;
    width: 100%;
    margin-left: 200px;
    font-weight: bold;
    text-align: center;
}

.qd-product-item {
    display: block;
    padding: 20px;
    border-bottom: 1px solid #eee;
    background-color: #fff;
    margin-bottom: 15px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.qd-product-info {
    display: grid;
    grid-template-columns: 150px 1fr;
    gap: 20px;
    align-items: start;
    margin-bottom: 15px;
}

.qd-product-details-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 15px;
    margin-top: 15px;
}

.qd-detail-item {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.qd-detail-label {
    font-weight: bold;
    font-size: 14px;
    color: #666;
}

.qd-detail-value {
    font-size: 16px;
    color: #333;
}

.qd-product-info img {
    width: 80px;
    height: 60px;
    object-fit: cover;
    margin-right: 15px;
    border: 1px solid #eee;
    border-radius: 4px;
    flex-shrink: 0;
}

.img-placeholder {
    width: 80px;
    height: 60px;
    background-color: #f0f0f0;
    margin-right: 15px;
    border: 1px solid #eee;
    border-radius: 4px;
    flex-shrink: 0;
}

.qd-product-details .name {
    font-weight: bold;
    margin-bottom: 5px;
}

.qd-product-status p {
    margin: 2px 0;
    font-size: 14px;
}

.qd-product-status .status-title {
    font-weight: bold;
    color: #E84100;
}
.qd-product-status .status-action {
    text-decoration: underline;
    cursor: pointer;
}


.qd-inquiry-box {
    display: flex;
    border: 1px solid #ddd;
    margin-top: 40px;
}

.qd-inquiry-box .label {
    flex-basis: 200px;
    padding: 20px;
    background-color: #f9f9f9;
    font-weight: bold;
    text-align: center;
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
}

.qd-inquiry-box .content {
    padding: 20px;
    flex-grow: 1;
}

.qd-inquiry-box p {
    margin: 0 0 10px 0;
    word-wrap: break-word;
    white-space: pre-wrap;
    line-height: 1.6;
}

/* 자체 제작 견적 섹션 스타일 */
.qd-custom-order-section {
    border: 1px solid #ddd;
    border-radius: 8px;
    margin-bottom: 40px;
    overflow: hidden;
}

.qd-custom-order-header {
    background-color: #f8f9fa;
    padding: 30px;
    border-bottom: 1px solid #ddd;
    text-align: center;
}

.qd-custom-order-header h3 {
    margin: 0 0 10px 0;
    font-size: 24px;
    font-weight: 600;
    color: #333;
}

.qd-custom-order-description {
    margin: 0;
    font-size: 16px;
    color: #666;
    line-height: 1.5;
}

.qd-custom-order-info {
    padding: 30px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 30px;
}

.qd-info-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 6px;
}

.qd-info-label {
    font-size: 14px;
    color: #888;
    margin-bottom: 8px;
    font-weight: 500;
}

.qd-info-value {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

/* 반응형 대응 */
@media (max-width: 768px) {
    .qd-custom-order-info {
        grid-template-columns: 1fr;
        gap: 20px;
        padding: 20px;
    }
    
    .qd-custom-order-header {
        padding: 20px;
    }
    
    .qd-custom-order-header h3 {
        font-size: 20px;
    }
}

/* 관리자 답변 스타일 */
.qd-reply-box {
    display: flex;
    border: 1px solid #ddd;
    margin-top: 40px;
}

.qd-reply-box .label {
    flex-basis: 200px;
    padding: 20px;
    background-color: #f9f9f9;
    font-weight: bold;
    text-align: center;
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
}

.qd-reply-box .content {
    padding: 20px;
    flex-grow: 1;
}

.qd-reply-box p {
    margin: 0 0 10px 0;
    word-wrap: break-word;
    white-space: pre-wrap;
    line-height: 1.6;
}

/* 관리자 첨부파일 스타일 */
.qd-attachment-box {
    display: flex;
    border: 1px solid #ddd;
    margin-top: 20px;
}

.qd-attachment-box .label {
    flex-basis: 200px;
    padding: 20px;
    background-color: #e7f3ff;
    font-weight: bold;
    text-align: center;
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1976d2;
}

.qd-attachment-box .content {
    padding: 20px;
    flex-grow: 1;
}

.attachment-file-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    margin-bottom: 8px;
}

.attachment-file-item .file-name {
    display: flex;
    align-items: center;
    flex: 1 1;
}

.attachment-file-item .file-size {
    margin-left: 8px;
}

/* 첨부 파일 스타일 */
.attached-files {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #eee;
}

.attached-files h4 {
    margin: 0 0 10px 0;
    font-size: 14px;
    color: #333;
}

.file-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    margin-bottom: 8px;
}

.file-name {
    font-size: 14px;
    color: #333;
    flex: 1 1;
}

.file-size {
    font-size: 12px;
    color: #888;
    margin-left: 8px;
}

.file-actions {
    display: flex;
    gap: 8px;
}

.btn-download, .btn-preview {
    padding: 6px 12px;
    font-size: 12px;
    border: 1px solid #007bff;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-download {
    background-color: #007bff;
    color: white;
}

.btn-download:hover {
    background-color: #0056b3;
}

.btn-preview {
    background-color: white;
    color: #007bff;
}

.btn-preview:hover {
    background-color: #f8f9fa;
}

.qd-page-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 50px;
}

.qd-page-actions .qd-btn-dark,
.qd-page-actions .qd-btn-primary {
    padding: 15px 60px;
    font-size: 16px;
    font-weight: bold;
}

.qd-btn-primary {
    background-color: #E84100;
    border: 1px solid #E84100;
    color: #fff;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .quotation-detail-page {
        margin: 20px auto;
    }

    .qd-main-title {
        font-size: 28px;
        margin-bottom: 30px;
    }

    .qd-summary-box {
        flex-direction: column;
        gap: 20px;
    }

    .qd-summary-grid {
        grid-template-columns: repeat(2, 1fr);
        width: 100%;
    }

    .qd-product-list-cols {
        margin-left: 150px;
        grid-template-columns: 3fr 1fr 2fr 1.5fr 1.5fr;
    }

    .qd-product-item {
        grid-template-columns: 150px 3fr 1fr 2fr 1.5fr 1.5fr;
    }

    .qd-product-info img, .img-placeholder {
        width: 60px;
        height: 60px;
        margin-right: 15px;
    }

    .qd-page-actions {
        margin-top: 40px;
    }

    .qd-page-actions .qd-btn-dark,
    .qd-page-actions .qd-btn-primary {
        padding: 12px 40px;
        font-size: 15px;
    }

    .qd-inquiry-box {
        flex-direction: column;
    }

    .qd-inquiry-box .label {
        flex-basis: auto;
        border-right: none;
        border-bottom: 1px solid #ddd;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .quotation-detail-page {
        padding: 0 15px;
        margin: 15px auto;
    }

    .qd-breadcrumb {
        font-size: 12px;
        margin-bottom: 20px;
    }

    .qd-main-title {
        font-size: 24px;
        margin-bottom: 25px;
    }

    .qd-summary-grid {
        grid-template-columns: 1fr;
        gap: 10px;
    }

    .qd-summary-item .label {
        width: 90px;
    }

    .qd-summary-actions {
        flex-direction: row;
        justify-content: center;
        width: 100%;
    }

    .qd-btn-dark, .qd-btn-light, .qd-btn-primary {
        padding: 8px 15px;
        font-size: 13px;
        width: 100%;
    }

    .qd-product-list-header {
        display: none;
    }

    .qd-product-list-cols {
        display: none;
    }
    
    .qd-product-item {
        grid-template-columns: 1fr;
        gap: 10px;
        padding: 15px;
        border: 1px solid #eee;
        border-radius: 5px;
        margin-bottom: 10px;
        text-align: left;
    }

    .qd-product-info {
        grid-column: auto;
    }

    .qd-product-info img, .img-placeholder {
        width: 70px;
        height: 70px;
    }
    
    .qd-product-item > span:not(:first-child)::before {
        content: attr(data-label);
        font-weight: bold;
        display: inline-block;
        width: 120px;
        margin-right: 10px;
    }

    .qd-product-status, .qd-product-qty, .qd-unit-price, .qd-total-price {
        text-align: left;
    }

    .qd-page-actions {
        flex-direction: column;
        gap: 10px;
        margin-top: 30px;
    }

    .qd-page-actions .qd-btn-dark,
    .qd-page-actions .qd-btn-primary {
        padding: 15px;
        font-size: 16px;
    }
} 

/* 기존 CSS는 유지하고 PDF 출력용 스타일 추가 */

@media print {
    /* 인쇄 시 네비게이션 및 버튼 숨기기 */
    .qd-breadcrumb,
    .qd-summary-actions,
    .qd-page-actions {
        display: none !important;
    }
    
    /* 페이지 여백 조정 */
    body {
        margin: 0;
        padding: 20px;
        font-size: 12px;
        line-height: 1.4;
    }
    
    /* 견적 상세 페이지 컨테이너 */
    .quotation-detail-page {
        width: 100%;
        max-width: none;
        margin: 0;
        padding: 0;
    }
    
    /* 제목 스타일 */
    .qd-main-title {
        font-size: 24px;
        margin-bottom: 20px;
        border-bottom: 2px solid #333;
        padding-bottom: 10px;
    }
    
    /* 요약 박스 스타일 */
    .qd-summary-box {
        border: 1px solid #333;
        padding: 15px;
        margin-bottom: 20px;
        page-break-inside: avoid;
    }
    
    .qd-summary-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }
    
    .qd-summary-item {
        display: flex;
        padding: 5px 0;
        border-bottom: 1px solid #eee;
    }
    
    .qd-summary-item .label {
        font-weight: bold;
        min-width: 100px;
        margin-right: 10px;
    }
    
    /* 제품 목록 헤더 */
    .qd-product-list-header {
        background-color: #f5f5f5 !important;
        border: 1px solid #333;
        display: grid;
        grid-template-columns: 2fr 1fr 2fr 1fr;
        gap: 10px;
        padding: 10px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    
    /* 제품 목록 */
    .qd-product-list {
        border: 1px solid #333;
    }
    
    .qd-product-item {
        display: grid;
        grid-template-columns: 2fr 1fr 2fr 1fr;
        gap: 10px;
        padding: 10px;
        border-bottom: 1px solid #ddd;
        page-break-inside: avoid;
    }
    
    .qd-product-image {
        width: 60px;
        height: 40px;
        object-fit: cover;
    }
    
    .qd-product-info {
        display: flex;
        gap: 10px;
        align-items: flex-start;
    }
    
    .qd-product-details {
        flex: 1 1;
    }
    
    .qd-product-name {
        font-weight: bold;
        margin-bottom: 5px;
    }
    
    .qd-product-code,
    .qd-product-size,
    .qd-product-options {
        font-size: 11px;
        color: #666;
        margin-bottom: 3px;
    }
    
    /* 문의사항 및 답변 */
    .qd-inquiry-box,
    .qd-reply-box {
        border: 1px solid #333;
        padding: 15px;
        margin: 20px 0;
        page-break-inside: avoid;
    }
    
    .qd-inquiry-box .label,
    .qd-reply-box .label {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 10px;
        display: block;
    }
    
    .qd-inquiry-box .content,
    .qd-reply-box .content {
        line-height: 1.6;
    }
    
    /* 페이지 나누기 강제 */
    .page-break {
        page-break-before: always;
    }
    
    /* 색상 조정 */
    * {
        print-color-adjust: exact !important;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/QuotationDetailPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,uCAAuC;IACvC,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8CAA8C;IAC9C,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,kCAAkC;IAClC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA,WAAW;AACX;IACI;QACI,0BAA0B;QAC1B,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,eAAe;AACf;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAO;AACX;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;;AAEA,+BAA+B;AAC/B;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,qCAAqC;QACrC,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,8CAA8C;IAClD;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,6BAA6B;IACjC;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;QACT,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;QACjB,qBAAqB;QACrB,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,gBAAgB;IACpB;;IAEA;;QAEI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA,gCAAgC;;AAEhC;IACI,wBAAwB;IACxB;;;QAGI,wBAAwB;IAC5B;;IAEA,cAAc;IACd;QACI,SAAS;QACT,aAAa;QACb,eAAe;QACf,gBAAgB;IACpB;;IAEA,mBAAmB;IACnB;QACI,WAAW;QACX,eAAe;QACf,SAAS;QACT,UAAU;IACd;;IAEA,WAAW;IACX;QACI,eAAe;QACf,mBAAmB;QACnB,6BAA6B;QAC7B,oBAAoB;IACxB;;IAEA,cAAc;IACd;QACI,sBAAsB;QACtB,aAAa;QACb,mBAAmB;QACnB,wBAAwB;IAC5B;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,aAAa;QACb,cAAc;QACd,6BAA6B;IACjC;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA,aAAa;IACb;QACI,oCAAoC;QACpC,sBAAsB;QACtB,aAAa;QACb,sCAAsC;QACtC,SAAS;QACT,aAAa;QACb,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA,UAAU;IACV;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,sCAAsC;QACtC,SAAS;QACT,aAAa;QACb,6BAA6B;QAC7B,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,uBAAuB;IAC3B;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;;;QAGI,eAAe;QACf,WAAW;QACX,kBAAkB;IACtB;;IAEA,cAAc;IACd;;QAEI,sBAAsB;QACtB,aAAa;QACb,cAAc;QACd,wBAAwB;IAC5B;;IAEA;;QAEI,iBAAiB;QACjB,eAAe;QACf,mBAAmB;QACnB,cAAc;IAClB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA,eAAe;IACf;QACI,yBAAyB;IAC7B;;IAEA,UAAU;IACV;QAGI,oCAAoC;IACxC;AACJ","sourcesContent":[".quotation-detail-page {\n    max-width: 1200px;\n    margin: 40px auto;\n    padding: 0 20px;\n    font-family: 'Noto Sans KR', sans-serif;\n    color: #333;\n}\n\n.qd-breadcrumb {\n    font-size: 14px;\n    color: #888;\n    margin-bottom: 40px;\n}\n\n.qd-breadcrumb .current {\n    font-weight: 500;\n    color: #333;\n}\n\n.qd-main-title {\n    font-size: 32px;\n    font-weight: bold;\n    text-align: center;\n    margin-bottom: 50px;\n}\n\n.qd-summary-box {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    border: 1px solid #ddd;\n    padding: 20px;\n    margin-bottom: 40px;\n}\n\n.qd-summary-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 15px 30px;\n    flex-grow: 1;\n}\n\n.qd-summary-vertical {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    flex-grow: 1;\n}\n\n.qd-summary-item {\n    font-size: 15px;\n}\n\n.qd-summary-item .label {\n    font-weight: bold;\n    display: inline-block;\n    width: 100px;\n    margin-right: 15px;\n}\n\n.qd-summary-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.qd-btn-dark, .qd-btn-light, .qd-btn-primary {\n    padding: 10px 20px;\n    font-size: 14px;\n    border-radius: 4px;\n    cursor: pointer;\n    text-align: center;\n}\n\n.qd-btn-dark {\n    background-color: #333;\n    border: 1px solid #333;\n    color: #fff;\n}\n\n.qd-btn-light {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    color: #333;\n}\n\n.qd-product-list-header {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 10px;\n    padding: 15px;\n    background-color: #f9f9f9;\n    border-top: 2px solid #333;\n    border-bottom: 1px solid #ddd;\n}\n\n.qd-product-list-cols {\n    display: grid;\n    grid-template-columns: 3fr 1fr 2fr 1.5fr 1.5fr;\n    width: 100%;\n    margin-left: 200px;\n    font-weight: bold;\n    text-align: center;\n}\n\n.qd-product-item {\n    display: block;\n    padding: 20px;\n    border-bottom: 1px solid #eee;\n    background-color: #fff;\n    margin-bottom: 15px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.qd-product-info {\n    display: grid;\n    grid-template-columns: 150px 1fr;\n    gap: 20px;\n    align-items: start;\n    margin-bottom: 15px;\n}\n\n.qd-product-details-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 15px;\n    margin-top: 15px;\n}\n\n.qd-detail-item {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.qd-detail-label {\n    font-weight: bold;\n    font-size: 14px;\n    color: #666;\n}\n\n.qd-detail-value {\n    font-size: 16px;\n    color: #333;\n}\n\n.qd-product-info img {\n    width: 80px;\n    height: 60px;\n    object-fit: cover;\n    margin-right: 15px;\n    border: 1px solid #eee;\n    border-radius: 4px;\n    flex-shrink: 0;\n}\n\n.img-placeholder {\n    width: 80px;\n    height: 60px;\n    background-color: #f0f0f0;\n    margin-right: 15px;\n    border: 1px solid #eee;\n    border-radius: 4px;\n    flex-shrink: 0;\n}\n\n.qd-product-details .name {\n    font-weight: bold;\n    margin-bottom: 5px;\n}\n\n.qd-product-status p {\n    margin: 2px 0;\n    font-size: 14px;\n}\n\n.qd-product-status .status-title {\n    font-weight: bold;\n    color: #E84100;\n}\n.qd-product-status .status-action {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n\n.qd-inquiry-box {\n    display: flex;\n    border: 1px solid #ddd;\n    margin-top: 40px;\n}\n\n.qd-inquiry-box .label {\n    flex-basis: 200px;\n    padding: 20px;\n    background-color: #f9f9f9;\n    font-weight: bold;\n    text-align: center;\n    align-self: stretch;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.qd-inquiry-box .content {\n    padding: 20px;\n    flex-grow: 1;\n}\n\n.qd-inquiry-box p {\n    margin: 0 0 10px 0;\n    word-wrap: break-word;\n    white-space: pre-wrap;\n    line-height: 1.6;\n}\n\n/* 자체 제작 견적 섹션 스타일 */\n.qd-custom-order-section {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    margin-bottom: 40px;\n    overflow: hidden;\n}\n\n.qd-custom-order-header {\n    background-color: #f8f9fa;\n    padding: 30px;\n    border-bottom: 1px solid #ddd;\n    text-align: center;\n}\n\n.qd-custom-order-header h3 {\n    margin: 0 0 10px 0;\n    font-size: 24px;\n    font-weight: 600;\n    color: #333;\n}\n\n.qd-custom-order-description {\n    margin: 0;\n    font-size: 16px;\n    color: #666;\n    line-height: 1.5;\n}\n\n.qd-custom-order-info {\n    padding: 30px;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 30px;\n}\n\n.qd-info-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 20px;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n}\n\n.qd-info-label {\n    font-size: 14px;\n    color: #888;\n    margin-bottom: 8px;\n    font-weight: 500;\n}\n\n.qd-info-value {\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n}\n\n/* 반응형 대응 */\n@media (max-width: 768px) {\n    .qd-custom-order-info {\n        grid-template-columns: 1fr;\n        gap: 20px;\n        padding: 20px;\n    }\n    \n    .qd-custom-order-header {\n        padding: 20px;\n    }\n    \n    .qd-custom-order-header h3 {\n        font-size: 20px;\n    }\n}\n\n/* 관리자 답변 스타일 */\n.qd-reply-box {\n    display: flex;\n    border: 1px solid #ddd;\n    margin-top: 40px;\n}\n\n.qd-reply-box .label {\n    flex-basis: 200px;\n    padding: 20px;\n    background-color: #f9f9f9;\n    font-weight: bold;\n    text-align: center;\n    align-self: stretch;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.qd-reply-box .content {\n    padding: 20px;\n    flex-grow: 1;\n}\n\n.qd-reply-box p {\n    margin: 0 0 10px 0;\n    word-wrap: break-word;\n    white-space: pre-wrap;\n    line-height: 1.6;\n}\n\n/* 관리자 첨부파일 스타일 */\n.qd-attachment-box {\n    display: flex;\n    border: 1px solid #ddd;\n    margin-top: 20px;\n}\n\n.qd-attachment-box .label {\n    flex-basis: 200px;\n    padding: 20px;\n    background-color: #e7f3ff;\n    font-weight: bold;\n    text-align: center;\n    align-self: stretch;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #1976d2;\n}\n\n.qd-attachment-box .content {\n    padding: 20px;\n    flex-grow: 1;\n}\n\n.attachment-file-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px;\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n    margin-bottom: 8px;\n}\n\n.attachment-file-item .file-name {\n    display: flex;\n    align-items: center;\n    flex: 1;\n}\n\n.attachment-file-item .file-size {\n    margin-left: 8px;\n}\n\n/* 첨부 파일 스타일 */\n.attached-files {\n    margin-top: 15px;\n    padding-top: 15px;\n    border-top: 1px solid #eee;\n}\n\n.attached-files h4 {\n    margin: 0 0 10px 0;\n    font-size: 14px;\n    color: #333;\n}\n\n.file-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px;\n    background-color: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 4px;\n    margin-bottom: 8px;\n}\n\n.file-name {\n    font-size: 14px;\n    color: #333;\n    flex: 1;\n}\n\n.file-size {\n    font-size: 12px;\n    color: #888;\n    margin-left: 8px;\n}\n\n.file-actions {\n    display: flex;\n    gap: 8px;\n}\n\n.btn-download, .btn-preview {\n    padding: 6px 12px;\n    font-size: 12px;\n    border: 1px solid #007bff;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.btn-download {\n    background-color: #007bff;\n    color: white;\n}\n\n.btn-download:hover {\n    background-color: #0056b3;\n}\n\n.btn-preview {\n    background-color: white;\n    color: #007bff;\n}\n\n.btn-preview:hover {\n    background-color: #f8f9fa;\n}\n\n.qd-page-actions {\n    display: flex;\n    justify-content: center;\n    gap: 15px;\n    margin-top: 50px;\n}\n\n.qd-page-actions .qd-btn-dark,\n.qd-page-actions .qd-btn-primary {\n    padding: 15px 60px;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.qd-btn-primary {\n    background-color: #E84100;\n    border: 1px solid #E84100;\n    color: #fff;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .quotation-detail-page {\n        margin: 20px auto;\n    }\n\n    .qd-main-title {\n        font-size: 28px;\n        margin-bottom: 30px;\n    }\n\n    .qd-summary-box {\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .qd-summary-grid {\n        grid-template-columns: repeat(2, 1fr);\n        width: 100%;\n    }\n\n    .qd-product-list-cols {\n        margin-left: 150px;\n        grid-template-columns: 3fr 1fr 2fr 1.5fr 1.5fr;\n    }\n\n    .qd-product-item {\n        grid-template-columns: 150px 3fr 1fr 2fr 1.5fr 1.5fr;\n    }\n\n    .qd-product-info img, .img-placeholder {\n        width: 60px;\n        height: 60px;\n        margin-right: 15px;\n    }\n\n    .qd-page-actions {\n        margin-top: 40px;\n    }\n\n    .qd-page-actions .qd-btn-dark,\n    .qd-page-actions .qd-btn-primary {\n        padding: 12px 40px;\n        font-size: 15px;\n    }\n\n    .qd-inquiry-box {\n        flex-direction: column;\n    }\n\n    .qd-inquiry-box .label {\n        flex-basis: auto;\n        border-right: none;\n        border-bottom: 1px solid #ddd;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .quotation-detail-page {\n        padding: 0 15px;\n        margin: 15px auto;\n    }\n\n    .qd-breadcrumb {\n        font-size: 12px;\n        margin-bottom: 20px;\n    }\n\n    .qd-main-title {\n        font-size: 24px;\n        margin-bottom: 25px;\n    }\n\n    .qd-summary-grid {\n        grid-template-columns: 1fr;\n        gap: 10px;\n    }\n\n    .qd-summary-item .label {\n        width: 90px;\n    }\n\n    .qd-summary-actions {\n        flex-direction: row;\n        justify-content: center;\n        width: 100%;\n    }\n\n    .qd-btn-dark, .qd-btn-light, .qd-btn-primary {\n        padding: 8px 15px;\n        font-size: 13px;\n        width: 100%;\n    }\n\n    .qd-product-list-header {\n        display: none;\n    }\n\n    .qd-product-list-cols {\n        display: none;\n    }\n    \n    .qd-product-item {\n        grid-template-columns: 1fr;\n        gap: 10px;\n        padding: 15px;\n        border: 1px solid #eee;\n        border-radius: 5px;\n        margin-bottom: 10px;\n        text-align: left;\n    }\n\n    .qd-product-info {\n        grid-column: auto;\n    }\n\n    .qd-product-info img, .img-placeholder {\n        width: 70px;\n        height: 70px;\n    }\n    \n    .qd-product-item > span:not(:first-child)::before {\n        content: attr(data-label);\n        font-weight: bold;\n        display: inline-block;\n        width: 120px;\n        margin-right: 10px;\n    }\n\n    .qd-product-status, .qd-product-qty, .qd-unit-price, .qd-total-price {\n        text-align: left;\n    }\n\n    .qd-page-actions {\n        flex-direction: column;\n        gap: 10px;\n        margin-top: 30px;\n    }\n\n    .qd-page-actions .qd-btn-dark,\n    .qd-page-actions .qd-btn-primary {\n        padding: 15px;\n        font-size: 16px;\n    }\n} \n\n/* 기존 CSS는 유지하고 PDF 출력용 스타일 추가 */\n\n@media print {\n    /* 인쇄 시 네비게이션 및 버튼 숨기기 */\n    .qd-breadcrumb,\n    .qd-summary-actions,\n    .qd-page-actions {\n        display: none !important;\n    }\n    \n    /* 페이지 여백 조정 */\n    body {\n        margin: 0;\n        padding: 20px;\n        font-size: 12px;\n        line-height: 1.4;\n    }\n    \n    /* 견적 상세 페이지 컨테이너 */\n    .quotation-detail-page {\n        width: 100%;\n        max-width: none;\n        margin: 0;\n        padding: 0;\n    }\n    \n    /* 제목 스타일 */\n    .qd-main-title {\n        font-size: 24px;\n        margin-bottom: 20px;\n        border-bottom: 2px solid #333;\n        padding-bottom: 10px;\n    }\n    \n    /* 요약 박스 스타일 */\n    .qd-summary-box {\n        border: 1px solid #333;\n        padding: 15px;\n        margin-bottom: 20px;\n        page-break-inside: avoid;\n    }\n    \n    .qd-summary-grid {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 10px;\n    }\n    \n    .qd-summary-item {\n        display: flex;\n        padding: 5px 0;\n        border-bottom: 1px solid #eee;\n    }\n    \n    .qd-summary-item .label {\n        font-weight: bold;\n        min-width: 100px;\n        margin-right: 10px;\n    }\n    \n    /* 제품 목록 헤더 */\n    .qd-product-list-header {\n        background-color: #f5f5f5 !important;\n        border: 1px solid #333;\n        display: grid;\n        grid-template-columns: 2fr 1fr 2fr 1fr;\n        gap: 10px;\n        padding: 10px;\n        font-weight: bold;\n        margin-bottom: 10px;\n    }\n    \n    /* 제품 목록 */\n    .qd-product-list {\n        border: 1px solid #333;\n    }\n    \n    .qd-product-item {\n        display: grid;\n        grid-template-columns: 2fr 1fr 2fr 1fr;\n        gap: 10px;\n        padding: 10px;\n        border-bottom: 1px solid #ddd;\n        page-break-inside: avoid;\n    }\n    \n    .qd-product-image {\n        width: 60px;\n        height: 40px;\n        object-fit: cover;\n    }\n    \n    .qd-product-info {\n        display: flex;\n        gap: 10px;\n        align-items: flex-start;\n    }\n    \n    .qd-product-details {\n        flex: 1;\n    }\n    \n    .qd-product-name {\n        font-weight: bold;\n        margin-bottom: 5px;\n    }\n    \n    .qd-product-code,\n    .qd-product-size,\n    .qd-product-options {\n        font-size: 11px;\n        color: #666;\n        margin-bottom: 3px;\n    }\n    \n    /* 문의사항 및 답변 */\n    .qd-inquiry-box,\n    .qd-reply-box {\n        border: 1px solid #333;\n        padding: 15px;\n        margin: 20px 0;\n        page-break-inside: avoid;\n    }\n    \n    .qd-inquiry-box .label,\n    .qd-reply-box .label {\n        font-weight: bold;\n        font-size: 14px;\n        margin-bottom: 10px;\n        display: block;\n    }\n    \n    .qd-inquiry-box .content,\n    .qd-reply-box .content {\n        line-height: 1.6;\n    }\n    \n    /* 페이지 나누기 강제 */\n    .page-break {\n        page-break-before: always;\n    }\n    \n    /* 색상 조정 */\n    * {\n        -webkit-print-color-adjust: exact !important;\n        color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
